import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcNote(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.75 10a.75.75 0 0 1 0-1.5h10.5a.75.75 0 0 1 0 1.5zM6.75 13a.75.75 0 0 1 0-1.5h6.5a.75.75 0 0 1 0 1.5zM6.75 16a.75.75 0 0 1 0-1.5h4.5a.75.75 0 0 1 0 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.5 2.625a.75.75 0 0 0-1.5 0V4H5.75A2.75 2.75 0 0 0 3 6.75v12.5A2.75 2.75 0 0 0 5.75 22h12.5A2.75 2.75 0 0 0 21 19.25V6.75A2.75 2.75 0 0 0 18.25 4H17V2.625a.75.75 0 0 0-1.5 0V4h-7zm-4 4.125c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v12.5c0 .69-.56 1.25-1.25 1.25H5.75c-.69 0-1.25-.56-1.25-1.25z",
    clipRule: "evenodd"
  }));
}
var IcNote = createNolIcon(/*#__PURE__*/forwardRef(SvgIcNote));

export { IcNote as I };
